// Mock data for Lockout Bros Emergency Services

export const companyInfo = {
  name: "Lockout Bros",
  tagline: "Emergency Services",
  phone: "(437) 663-0763",
  phoneLink: "tel:+14376630763",
  email: "info@lockoutbros.ca",
  instagram: "https://www.instagram.com/thelockoutbros/",
  serviceArea: "Greater Toronto Area (GTA)",
  serviceFee: "$20",
  hours: "24/7",
  logo: "https://customer-assets.emergentagent.com/job_21c7743d-d842-4fad-a40e-013e5ec6fd44/artifacts/s7d6lr93_ChatGPT%20Image%20Jan%204%2C%202026%2C%2011_36_46%20PM.png"
};

export const services = [
  {
    id: 1,
    title: "Car Lockouts",
    description: "Locked out of your vehicle? We'll get you back on the road in minutes.",
    icon: "Car"
  },
  {
    id: 2,
    title: "Home Lockouts",
    description: "Can't get into your house? Our experts will safely unlock your door.",
    icon: "Home"
  },
  {
    id: 3,
    title: "Commercial Lockouts",
    description: "Business locked? We provide fast service for all commercial properties.",
    icon: "Building2"
  },
  {
    id: 4,
    title: "Emergency 24/7",
    description: "Day or night, we're always available when you need us most.",
    icon: "Clock"
  }
];

export const features = [
  {
    id: 1,
    title: "24/7 Availability",
    description: "We never close. Call us anytime, day or night.",
    icon: "Clock"
  },
  {
    id: 2,
    title: "GTA-Wide Coverage",
    description: "We travel anywhere in the Greater Toronto Area.",
    icon: "MapPin"
  },
  {
    id: 3,
    title: "$20 Service Fee",
    description: "Low service call fee for our professional technicians.",
    icon: "DollarSign"
  },
  {
    id: 4,
    title: "Fast Response",
    description: "Average arrival time under 30 minutes.",
    icon: "Zap"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Toronto",
    rating: 5,
    text: "Locked out at 2 AM and they were here in 20 minutes! Lifesavers!"
  },
  {
    id: 2,
    name: "Michael R.",
    location: "Mississauga",
    rating: 5,
    text: "Professional, fast, and affordable. Highly recommend Lockout Bros!"
  },
  {
    id: 3,
    name: "Jennifer L.",
    location: "Brampton",
    rating: 5,
    text: "Got me back into my car in less than 5 minutes. Amazing service!"
  }
];

export const coverageAreas = [
  "Toronto",
  "Mississauga",
  "Brampton",
  "Vaughan",
  "Markham",
  "Richmond Hill",
  "Scarborough",
  "North York",
  "Etobicoke",
  "Oakville",
  "Burlington",
  "Ajax",
  "Pickering",
  "Oshawa"
];
